import OfferEvent from '@models/offer/OfferEvent';
import { Location } from 'vue-router';

export type SuggestionsFunction = (query: string) => string[];

export type Match = {
    match: string;
    type: MatchType;
    bucket: MatchBucket;
    eventId: number;
};

export const MatchType = {
    Exact: 'Exact',
    StartsWith: 'StartsWith',
    AnyWordStartsWith: 'AnyWordStartsWith',
    AnyWordExact: 'AnyWordExact',
    FirstWordExact: 'FirstWordExact',
    Includes: 'Includes',
} as const;
export type MatchType = typeof MatchType[keyof typeof MatchType];

export const MatchBucket = {
    Competitor: 'Competitor',
    Tournament: 'Tournament',
} as const;
export type MatchBucket = typeof MatchBucket[keyof typeof MatchBucket];

export type SearchResultsTournament = {
    id: OfferEvent['tournamentId'];
    name: OfferEvent['tournamentName'];
    categoryId: OfferEvent['categoryId'];
    sportId: OfferEvent['sportId'];
    location: Location,
};

export type SearchResultsEvent = OfferEvent;
